export const isMobileRegEx = RegExp(
  /Mobile|iP(hone|od)|Android|Audiovox|AvantGo|BlackBerry|BB10|EPOC|LGE-|Motorola|IEMobile|Kindle|NetFront|Nitro|Nokia|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Obigo|Palm|Panasonic|Philips|Plucker|RegKing|Sanyo|Smartphone|Sony|Symbian|Blazer|Dolfin|Dolphin|Skyfire|UP\.Browser|WAP\d\.|Windows (?:CE|Phone)|Zune|Xiino|J2ME|MIDP|CLDC/
);
